/**
 * Versão do sistema de cobranças
 * Esta versão é exibida na barra lateral para informar aos usuários sobre atualizações
 */
export const SYSTEM_VERSION = '2.0.316';
export const LAST_UPDATE_DATE = '07/10/2026';
